module.exports = __webpack_public_path__ + "static/media/Dragon2.be5cc72e.png";